<script>
	import { Link } from 'svelte-routing';
	import { _ } from 'svelte-i18n';


	import BaseLayer from "./../components/BaseLayer.svelte";
</script>

<BaseLayer  --bg-overlay="url(/assets/bg/home.svg)">
	<div class="text-center">

		<div class="card w-full bg-base-100 rounded-none rounded-t-3xl absolute bottom-0 drop-shadow-[0_-8px_5px_rgba(0,0,0,0.1)]">
		  <figure class="absolute top-0 bottom-0">
			<img class="w-full h-full object-cover" src="/assets/bg/valley-90388_1920.jpg"/>
		  </figure>

		  <div class="card-body items-center text-center relative z-50">
		    <h2 class="card-title uppercase font-serif text-4xl"> {$_('home.welcome')} </h2>
		    <p class="font-serif font-bold text-md"> {$_('home.cta')} </p>
		    <div class="card-actions justify-end py-16">
		      <Link class="btn px-4 py-2 !uppercase !font-serif text-2xl btn-accent" to="trails"> {$_('home.button')} </Link>
		    </div>
		  </div>
		</div>

	</div>
</BaseLayer>

